<script>

import Input from "./Input.svelte";

export let value = null

let readableValue = "Inherit"

if (value !== null) {
    readableValue = `${value * 100}`
}

const isValid = (value) => {
    
    return !isNaN(value)
}

$: {
    value = parseInt(readableValue.replace("%", "")) * 0.01
}

</script>

<div class="input-wrap">
    <Input isValid={isValid} defaultValue="inherit" defaultLabel="inherit" bind:value={readableValue}/>
</div>


<style>



</style>